const SLIDE_DURATION = 200;

const initial = () => {
    const menuIcon = document.getElementById('menu');
    const menuContainer = document.getElementById('menu-container');

    if (!menuIcon || !menuContainer) {
        return;
    }

    let slideTimeout = null;

    const stopSlide = () => {
        if (slideTimeout) {
            clearTimeout(slideTimeout);
            slideTimeout = null;
        }
    };

    const resetStyles = () => {
        menuContainer.style.removeProperty('height');
        menuContainer.style.removeProperty('overflow');
        menuContainer.style.removeProperty('transition');
    };

    const slideDown = () => {
        stopSlide();

        menuContainer.style.display = 'block';
        const height = menuContainer.scrollHeight;
        menuContainer.style.overflow = 'hidden';
        menuContainer.style.height = '0px';
        menuContainer.style.transition = `height ${SLIDE_DURATION}ms ease`;

        requestAnimationFrame(() => {
            menuContainer.style.height = `${height}px`;
        });

        slideTimeout = setTimeout(() => {
            resetStyles();
            slideTimeout = null;
        }, SLIDE_DURATION);
    };

    const slideUp = () => {
        stopSlide();

        menuContainer.style.overflow = 'hidden';
        menuContainer.style.height = `${menuContainer.scrollHeight}px`;
        menuContainer.style.transition = `height ${SLIDE_DURATION}ms ease`;

        requestAnimationFrame(() => {
            menuContainer.style.height = '0px';
        });

        slideTimeout = setTimeout(() => {
            menuContainer.style.display = 'none';
            resetStyles();
            slideTimeout = null;
        }, SLIDE_DURATION);
    };

    menuIcon.addEventListener('click', () => {
        menuIcon.classList.toggle('active');

        if (menuIcon.classList.contains('active')) {
            slideDown();
        } else {
            slideUp();
        }
    });
};

export default initial;
